import React, { useState, useEffect } from "react";
import DropdownSelect from "components/Dropdown/DropdownSelect";
import { UserPlus, Users, Pencil } from "lucide-react";

export default function Scores({ scoresData, setScoresData, players, clearAllScores, ruleStartingPoint = 10, saveRound }) {

    const [currentScoreEntry, setCurrentScoreEntry] = useState(
        {
            playerId: "",
            firstName: "",
            lastName: "",
            points: ruleStartingPoint ?? 0,
            grossScore: 0,
            netScore: 0,
            birdies: 0,
            eagles: 0,
            hio: 0,
            prizeMoney: 0,
            hcp: 0,
            win: true
        }
    );




    useEffect(() => {
        if (players?.length > 0) {
            setCurrentScoreEntry((prev) => ({
                ...prev,
                playerId: prev.playerId || players[0].id,
                firstName: prev.firstName || players[0].firstName,
                lastName: prev.lastName || players[0].lastName
            }));
        }
    }, [players]);






    const handleFieldChange = (field, value) => {
        setCurrentScoreEntry((prev) => ({ ...prev, [field]: value }));
    };
    const getNextPoints = (nextPlayerPosition, startPoints) => {
        return startPoints - nextPlayerPosition >= 0 ? startPoints - nextPlayerPosition : 0;
    }



    // TODO - make it so that parent component get updated automaticlly and don't need to press "Submit all and run this function"
    const handleSubmit = () => {

    };

    const onChangePlayer = (player) => {
        if (!player) return;

        if (player.id.includes("guest")) {
            const guestId = getNextGuestId();

            setCurrentScoreEntry({
                playerId: guestId,
                id: guestId,
                firstName: "Gäst",
                lastName: "Gästsson",
                points: 0,
                grossScore: 0,
                netScore: 0,
                birdies: 0,
                eagles: 0,
                hio: 0,
                prizeMoney: 0,
                hcp: 0,
                win: false
            });

            return;
        }

        const memberCount = scoresData.filter(s => !s.playerId?.startsWith("guest")).length;
        setCurrentScoreEntry({
            playerId: player.id,
            id: player.id,
            firstName: player.firstName,
            lastName: player.lastName,
            points: Math.max(ruleStartingPoint - memberCount, 0),
            grossScore: 0,
            netScore: 0,
            birdies: 0,
            eagles: 0,
            hio: 0,
            prizeMoney: 0,
            hcp: 0,
            win: false
        });
    };
    const availablePlayers = players.filter(
        (player) => !scoresData.some(score => score.playerId === player.id)

    );


    const addPlayerScore = (e) => {
        e.preventDefault();

        const isGuest = currentScoreEntry.playerId?.startsWith("guest");
        const entryToSave = isGuest ? { ...currentScoreEntry, points: 0 } : currentScoreEntry;

        const updatedScores = [...scoresData, entryToSave];
        setScoresData(updatedScores);

        const unregisteredPlayers = players.filter(
            (player) => !updatedScores.some((score) => score.playerId === player.id)
        );

        const nextPlayer = unregisteredPlayers[0];
        const memberCount = updatedScores.filter(s => !s.playerId?.startsWith("guest")).length;

        setCurrentScoreEntry({
            playerId: nextPlayer ? nextPlayer.id : "",
            firstName: nextPlayer ? nextPlayer.firstName : "",
            lastName: nextPlayer ? nextPlayer.lastName : "",
            points: Math.max(ruleStartingPoint - memberCount, 0),
            grossScore: 0,
            netScore: 0,
            birdies: 0,
            eagles: 0,
            hio: 0,
            prizeMoney: 0,
            hcp: 0,
            win: false
        });
    };

    const removePlayerScore = (player) => {
        setScoresData(prev =>
            prev.filter(score => score.playerId !== player.playerId)
        );
    }
    const editPlayer = (player, index) => {
        removePlayerScore(player)
        setCurrentScoreEntry(player)


    }

    const getNextGuestId = () => {
        const guestIds = scoresData
            .map(s => s.playerId)
            .filter(id => id?.startsWith("guest"));

        if (guestIds.length === 0) return "guest1";

        const numbers = guestIds
            .map(id => parseInt(id.replace("guest", ""), 10))
            .filter(n => !isNaN(n));

        const next = numbers.length ? Math.max(...numbers) + 1 : 1;

        return `guest${next}`;
    };



    const playerScoreForm = (player, index) => {
        const winAlreadyAssigned = scoresData.some(s => s.win === true);

        return (
            <form
                className="edit-score--form"
                onSubmit={addPlayerScore}
                key={index}
            >
                <div className="form-row">
                    <div className="form-group form-group--box">
                        <label htmlFor={`points-${index}`}>Points</label>
                        <input
                            id={`points-${index}`}
                            name="points"
                            type="number"
                            min="0"
                            value={currentScoreEntry?.points}
                            onChange={(e) => handleFieldChange("points", e.target.value)}
                        />
                    </div>

                    <div className="form-group form-group--box">
                        <label htmlFor={`grossScore-${index}`}>Gross</label>
                        <input
                            id={`grossScore-${index}`}
                            name="grossScore"
                            type="number"
                            min="0"
                            value={currentScoreEntry?.grossScore}
                            onChange={(e) => handleFieldChange("grossScore", e.target.value)}
                        />
                    </div>

                    <div className="form-group form-group--box">
                        <label htmlFor={`netScore-${index}`}>Net</label>
                        <input
                            id={`netScore-${index}`}
                            name="netScore"
                            type="number"
                            min="0"
                            value={currentScoreEntry?.netScore}
                            onChange={(e) => handleFieldChange("netScore", e.target.value)}
                        />
                    </div>

                    <div className="form-group form-group--box">
                        <label htmlFor={`prizeMoney-${index}`}>Prize money</label>
                        <input
                            id={`prizeMoney-${index}`}
                            name="prizeMoney"
                            type="number"
                            min="0"
                            value={currentScoreEntry?.prizeMoney}
                            onChange={(e) => handleFieldChange("prizeMoney", e.target.value)}
                        />
                    </div>



                </div>

                <div className="form-row">
                    <div className="form-group form-group--box">
                        <label htmlFor={`birdies-${index}`}>Birdies</label>
                        <input
                            id={`birdies-${index}`}
                            name="birdies"
                            type="number"
                            min="0"
                            value={currentScoreEntry?.birdies}
                            onChange={(e) => handleFieldChange("birdies", e.target.value)}
                        />
                    </div>

                    <div className="form-group form-group--box">
                        <label htmlFor={`eagles-${index}`}>Eagles</label>
                        <input
                            id={`eagles-${index}`}
                            name="eagles"
                            type="number"
                            min="0"
                            value={currentScoreEntry?.eagles}
                            onChange={(e) => handleFieldChange("eagles", e.target.value)}
                        />
                    </div>

                    <div className="form-group form-group--box">
                        <label htmlFor={`hio-${index}`}>HIO</label>
                        <input
                            id={`hio-${index}`}
                            name="hio"
                            type="number"
                            min="0"
                            value={currentScoreEntry?.hio}
                            onChange={(e) => handleFieldChange("hio", e.target.value)}
                        />
                    </div>


                    <div className="form-group form-group--box">
                        <label htmlFor={`hcp-${index}`}>HCP</label>
                        <input
                            id={`hcp-${index}`}
                            name="hcp"
                            type="number"
                            min="-10"
                            max="54"
                            step="0.1"
                            value={currentScoreEntry?.hcp}
                            onChange={(e) => handleFieldChange("hcp", e.target.value)}
                        />
                    </div>
                </div>


                {!winAlreadyAssigned && (
                    <div className="form-group form-group-checkbox">
                        <label>Omgångens vinnare</label>
                        <input
                            type="checkbox"
                            id={`win-${index}`}
                            name="win"
                            checked={currentScoreEntry?.win === true}
                            onChange={(e) => handleFieldChange("win", e.target.checked)}
                        />
                    </div>
                )}

                <button className="button button--full-width button--save" type="submit">
                    Spara score
                </button>
            </form>
        )

    }


    return (
        <div>
            <div className="register-scores-container">
                <div className="edit-player-container">

                    <div className="select-player">
                        <div className="box-header">
                            <UserPlus size={17} /> <h4> Lägg spelarresultat</h4>
                        </div>
                        <div className="edit-score">
                            <span>Spelare:</span>

                            <DropdownSelect
                                items={[
                                    ...availablePlayers,
                                    { firstName: "", lastName: "", value: "Gäst", id: "guest", playerId: "guest" }
                                ]}
                                value={
                                    currentScoreEntry.playerId?.startsWith("guest")
                                        ? "guest"
                                        : currentScoreEntry.playerId
                                }
                                onChange={onChangePlayer}
                                placeholder="Välj spelare"
                                name="id"
                            />

                            {currentScoreEntry.playerId.includes("guest") &&
                                <div className="form-row">
                                    <div className="form-group form-group--thick">
                                        <label htmlFor="firstName">Förnamn</label>
                                        <input
                                            name="firstName"
                                            type="text"
                                            value={currentScoreEntry.firstName || ""}
                                            onChange={(e) => handleFieldChange("firstName", e.target.value)} />

                                    </div>

                                    <div className="form-group form-group--thick">
                                        <label htmlFor="lastName">Efternamn</label>
                                        <input
                                            name="lastName"
                                            type="text"
                                            value={currentScoreEntry.lastName || ""}
                                            onChange={(e) => handleFieldChange("lastName", e.target.value)} />

                                    </div>

                                </div>
                            }




                        </div>
                        {currentScoreEntry?.playerId !== "" &&
                            playerScoreForm(currentScoreEntry, scoresData.length)
                        }



                    </div>

                </div >
                <div className="added-scores">
                    <div className="box-header">
                        <Users size={17} /> <h4> Tillagda resultat</h4>
                    </div>
                    {(() => {
                        const sorted = [...scoresData].sort((a, b) => {
                            const netDiff = Number(a.netScore || 0) - Number(b.netScore || 0);
                            if (netDiff !== 0) return netDiff;
                            return Number(a.hcp || 0) - Number(b.hcp || 0);
                        });

                        let lastNet = null, lastHcp = null, lastRank = null;
                        sorted.forEach((s, i) => {
                            const net = Number(s.netScore || 0);
                            const hcp = Number(s.hcp || 0);
                            if (net === lastNet && hcp === lastHcp) {
                                s.position = lastRank;
                            } else {
                                s.position = i + 1;
                                lastNet = net;
                                lastHcp = hcp;
                                lastRank = s.position;
                            }
                        });

                        return sorted.map((playerScore, index) => {
                            const player = players.find(p => p.id === playerScore.playerId);
                            const displayName = player
                                ? `${player.firstName} ${player.lastName}`
                                : `${playerScore.firstName?.length > 1 ? playerScore.firstName : "Gäst"} ${playerScore.lastName}`;

                            return (
                                <div className="stats-panel stats-panel--player-result" key={index}>
                                    <div className="">
                                        <h4><span className="stat-name">#{playerScore.position} </span>{displayName}</h4>
                                        <div className="panel-row">
                                            <p className="stat-value stat-value--green">{playerScore.netScore} <span className="stat-name">net</span></p>
                                            <p className="stat-value stat-value--green">{playerScore.grossScore} <span className="stat-name">brutto</span></p>
                                        </div>
                                    </div>
                                    <div className="panel-row">
                                        <p className="stat-value stat-value--green">{playerScore.points} <span className="stat-name">Poäng</span></p>
                                    </div>
                                    <p className="clickable" onClick={() => editPlayer(playerScore)}><Pencil size={15} /></p>
                                </div>
                            );
                        });
                    })()}
                </div>



            </div>
            <div className="save-score-container">
                <button
                    className="button button--save button--center"
                    onClick={() => saveRound()}
                >
                    Spara runda
                </button>
            </div>
        </div>
    );
}
